import { createSelector } from 'reselect';
import { selectors as userSelectors } from '@saucelabs/sl-module-user';

import { SESSION_INACTIVE_REASONS } from '../../constants';
import { GlobalState } from '../../reducers';

const secondsLeftSelector = (state: GlobalState) => (
  state.apps.manual.rdcSession.session.secondsLeft
);

const sessionClosedReasonSelector = (state: GlobalState):
keyof typeof SESSION_INACTIVE_REASONS | '' => (
  state.apps.manual.rdcSession.session.sessionClosedReason
);

const sessionExpiryBannerSelector = createSelector([
  secondsLeftSelector,
], (secondsLeft) => ({
  secondsLeft,
}));

export default {
  sessionClosedReasonSelector,
  sessionExpiryBannerSelector,
};
